<template>
  <div class="goods-form">
    <div class="page-container">
      <el-row>
        <div class="p_1">商品详细信息</div>
        <el-col :xs="24" :md="24" :lg="24" class="item-text">
          <span class="tit_t">{{listData.CHEM_NAME}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">CAS号</span>
          <span class="value">{{listData.CHEM_ID}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">管制类型</span>
          <span class="value">{{listData.CONTROLTYPE}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">剩余量</span>
          <span class="value">{{listData.CURRENT_VOLUME}}G</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">购买量</span>
          <span class="value">{{listData.INIT_VOLUME}}G</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">生产厂商</span>
          <span class="value">{{listData.COMPANY_SRC}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">销售厂商</span>
          <span class="value">{{listData.COMPANY_SALE}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">销售厂商电话</span>
          <span class="value">{{listData.COMPANY_SALE_PHONE}}</span>
        </el-col>

        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">柜号</span>
          <span class="value">{{listData.CABINET_ID}}</span>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8" class="item-text">
          <span class="key">动作</span>
          <span class="value">{{listData.CABINET_ACTIVE}}</span>
        </el-col>
        <div v-for="item in listMsg">
          <div class="line" style="margin-top: 20px"></div>
          <div class="p_1" >台账信息</div>
          <el-col :xs="24" :md="24" :lg="24" class="item-text">
            <span class="key">使用台账号</span>
            <span class="tit_t">{{item.LEDGER_NO}}</span>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8" class="item-text">
            <span class="key">用量</span>
            <span class="value">{{item.USE_VOLUME}}</span>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8" class="item-text">
            <span class="key">使用者1</span>
            <span class="value">{{item.USER_NAME_1}}</span>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8" class="item-text">
            <span class="key">使用者2</span>
            <span class="value">{{item.USER_NAME_2}}</span>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8" class="item-text">
            <span class="key">备注</span>
            <span class="value">{{item.REMARK}}</span>
          </el-col>
          <el-col :xs="24" :md="24" :lg="24" class="item-text">
            <span class="key">记录时间</span>
            <span class="value">{{item.USE_DATE_V}}</span>
          </el-col>
          <el-col :xs="24" :md="24" :lg="24" class="item-text">
            <el-button type="danger"  size="medium" style="float: right" @click="deleteLedger(item)">删除</el-button>
          </el-col>
        </div>

      </el-row>
      <div class="line" style="margin-top: 20px"></div>
      <el-button plain @click="back">返回</el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import parameterMessage from 'api/Message/parameterMessage.js'
const _parameterMessage = new parameterMessage()

export default {

  mounted() {
    this.getParameterDetail()
  },

  data() {
    return {
      listData:{},
      listMsg:[],
    }
  },
  methods: {
    // 上传图片钩子函数
    back() {
      this.$router.back()
    },
    getParameterDetail(){
        // console.log(this.$route.params.storageNo)
        let list ='all'
        if (this.$route.params.storageNo){
            _parameterMessage.getParameterDetail(this.$route.params.storageNo).then(res => {
                this.listData = res
            })
            _parameterMessage.getParameterMsg(100,0,this.$route.params.storageNo,list).then(res => {
                this.listMsg = res.items
            })
        }
    },
  //    删除台账
      deleteLedger(item) {
        _parameterMessage.deleteParameter(item.LEDGER_NO).then(res=>{
            this.listMsg =[]
            let list ='all'
            _parameterMessage.getParameterMsg(10,0,this.$route.params.storageNo,list).then(res => {
                this.listMsg = res.items
            })
            this.$message({
                message: '删除成功',
                type: 'success'
            })
        })

      }
  },
  components: {

  watch: {

    }

  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/mixin.styl';
  .p_1 {
    width 100%
    height 30px
    line-height 30px
    font-size:16px;
    font-family:SimSun;
    font-weight:bold;
    color:rgba(62,62,62,1)
    margin-bottom 25px
    text-align center
  }
  .tit_t {
    width 100%
    height 30px
    line-height 30px
    font-size:14px;
    font-family:SimSun;
    font-weight:bold;
    color:rgba(62,62,62,1)
    margin-bottom 15px
  }
</style>
